<template>
  <div id="app">
    <router-view></router-view>
    <notifications group="notification" style="margin-top: 30px !important" />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
export default {
  async created() {
    const promises = [
      new Promise(() => this.doInitFirebase()),
      new Promise(() => this.doInit()),
    ];
    Promise.all(promises).then();
    if (!this.anonymousToken) {
      const firebaseUser = await firebase.auth().signInAnonymously();
    }
  },
  name: "app",
  methods: {
    ...mapActions({
      doInitFirebase: "0/doInitFirebase",
      doInit: "0/doInit",
    }),
  },
  data() {
    return {
      anonymousToken: "",
    };
    // anonymousToken ''
  },
  // setup() {
  //   const store = useStore()
  //   const anonymousToken = ref('')
  //   return {
  //     store,
  //     anonymousToken
  //   }
  // },
  mounted() {
    //set language
    const language = localStorage.getItem("language");
    if (!language || language == "ar") {
      localStorage.setItem("language", "ar");
      document.body.setAttribute("dir", "rtl");
      return;
    } else {
      localStorage.setItem("language", "en");
      document.body.setAttribute("dir", "ltr");
    }
  },
};
</script>
<style lang='scss'>
@import url("https://fonts.googleapis.com/css2?family=Cairo:wght@200;300;400;500;600;700;800;900&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,wght@0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;0,1000;1,200;1,300;1,400;1,500;1,600;1,700;1,800&family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap");

@media only screen and (min-width: 600px) {
  *::-webkit-scrollbar {
    width: 8px !important;
    height: 8px !important;
    border-radius: 10px !important;
  }

  *::-webkit-scrollbar-thumb {
    border-radius: 10px !important;
    background: #51cb89 !important;
  }
}

::-moz-selection {
  /* Code for Firefox */
  background: #122a50 !important;
}

::selection {
  background: #122a50 !important;
}
</style>


<style  lang="scss">
body {
  overflow-x: hidden;
}
*,
html {
  scroll-behavior: smooth !important;
}
body[dir="ltr"] {
  font-family: "Nunito", sans-serif !important;
}
body[dir="rtl"] {
  font-family: "Cairo", sans-serif !important;
}
</style>